<ng-container *ngIf="isLoading">
  <ng-container [ngTemplateOutlet]="loadingTemplate || loadingTemplateDefault"></ng-container>
  <ng-template #loadingTemplateDefault>
    <app-dashboard-chart-loading-template></app-dashboard-chart-loading-template>
  </ng-template>
</ng-container>

<ng-container *ngIf="error && !isLoading">
  <ng-container [ngTemplateOutlet]="errorTemplate || errorTemplateDefault"></ng-container>
  <ng-template #errorTemplateDefault>
    <app-dashboard-chart-error-template [error]="error"></app-dashboard-chart-error-template>
  </ng-template>
</ng-container>

<ng-container *ngIf="!isLoading && !error">
  <ng-content></ng-content>
</ng-container>
